var MiddlewareRunner = /** @class */ (function () {
    function MiddlewareRunner() {
        this.middlewares = [];
    }
    MiddlewareRunner.prototype.addMiddleware = function (middleware) {
        this.middlewares.push(middleware);
        return this;
    };
    MiddlewareRunner.prototype.execute = function (args) {
        return this.middlewares.reduce(function (result, middleware) { return middleware(result); }, args);
    };
    return MiddlewareRunner;
}());
export { MiddlewareRunner };
